import React from 'react'
import { Link } from 'react-router-dom'
import { styled } from 'styled-components'

const Flagship = () => {
  return (
    <Container>
        <h1>Our African Materials and Research Society.</h1>
        <Link to='/signup'><button className='signup-btn'>Become a Member</button></Link>
    </Container>
  )
}

const Container = styled.section`
  background-color: whitesmoke;
  padding: 5rem 2rem;
  text-align: center;
  h1{
    font-size: 4rem;
    line-height: 1.2;
  }
  .signup-btn{
    cursor: pointer;
    padding: 1em 2em;
    font-size: 1.2rem;
    margin-bottom: 2em;
    font-weight: 400;
    border-radius: 50px;
    border: none;
    color: var(--color-white);
    background-color: var(--color-black);
    transition: all 0.3s ease-in-out;
    &:hover{
      padding: 1em 2.5em;
      background-color:var(--color-black-light);
    }
  }
  /* Media Queries */
  @media only screen and (min-width: 800px){
    padding: 5rem 5rem;
  }

  @media only screen and (min-width: 1200px){
    padding: 5rem 10rem;
  }
`;

export default Flagship